import type { IncidentSeverity } from "../../types/incidents";

interface SeverityBadgeProps {
  severity: IncidentSeverity;
}

const colorMap: Record<IncidentSeverity, string> = {
  minor: "var(--aptean-color-neutral-400)",
  major: "var(--aptean-color-warning)",
  critical: "var(--aptean-color-error)",
};

export function SeverityBadge({ severity }: SeverityBadgeProps) {
  return (
    <span
      className={`aptean-severity-badge aptean-severity-badge--${severity}`}
      style={{ "--badge-color": colorMap[severity] } as React.CSSProperties}
      aria-label={severity}
    >
      {severity}
    </span>
  );
}
